/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Recording_Auto_StopInputs */

const en_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording will stop automatically at event end time`)
};

const fr_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'enregistrement s'arrêtera automatiquement à la fin de l'événement`)
};

const de_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aufzeichnung wird automatisch zum Ende der Veranstaltung gestoppt.`)
};

const it_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La registrazione si interromperà automaticamente al termine dell'evento`)
};

const ru_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись автоматически остановится по окончании мероприятия.`)
};

const es_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La grabación se detendrá automáticamente al finalizar el evento.`)
};

const zh_cn2_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制将在活动结束时自动停止。`)
};

const ja_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント終了時に録画は自動的に停止します`)
};

const hi_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समाप्त होने पर रिकॉर्डिंग अपने आप बंद हो जाएगी।`)
};

const pt_pt2_audio_recorder_recording_auto_stop = /** @type {(inputs: Audio_Recorder_Recording_Auto_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gravação será interrompida automaticamente ao término do evento.`)
};

/**
* | output |
* | --- |
* | "Recording will stop automatically at event end time" |
*
* @param {Audio_Recorder_Recording_Auto_StopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_recording_auto_stop = /** @type {((inputs?: Audio_Recorder_Recording_Auto_StopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Recording_Auto_StopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_recording_auto_stop(inputs)
	if (locale === "de") return de_audio_recorder_recording_auto_stop(inputs)
	if (locale === "it") return it_audio_recorder_recording_auto_stop(inputs)
	if (locale === "ru") return ru_audio_recorder_recording_auto_stop(inputs)
	if (locale === "es") return es_audio_recorder_recording_auto_stop(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_recording_auto_stop(inputs)
	if (locale === "ja") return ja_audio_recorder_recording_auto_stop(inputs)
	if (locale === "hi") return hi_audio_recorder_recording_auto_stop(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_recording_auto_stop(inputs)
	return en_audio_recorder_recording_auto_stop(inputs)
});